module.exports = __webpack_public_path__ + "media/images/FFD_Loading-4d25de304ddac57f6deaf868a65f6161.png";